import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Lenis from "lenis";

// Cinematic smooth scrolling on visitor pages. Excludes the booking page
// (Calendly embed) and the admin dashboard, and respects reduced-motion.
const EXCLUDE = /^\/(book|admin)\b/;

export default function SmoothScroll() {
  const { pathname } = useLocation();

  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce || EXCLUDE.test(pathname)) {
      window.__lenis = null;
      return;
    }

    const lenis = new Lenis({
      lerp: 0.085,
      smoothWheel: true,
      wheelMultiplier: 1,
      touchMultiplier: 1.4,
    });
    window.__lenis = lenis;

    let raf = requestAnimationFrame(function loop(time) {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    });

    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, [pathname]);

  return null;
}

// Smoothly scroll to an in-page anchor, using Lenis when active.
export const scrollToTarget = (el, offset = -72) => {
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset });
  else el.scrollIntoView({ behavior: "smooth", block: "start" });
};
